module.exports = __webpack_public_path__ + "img/dialog-bg.cd3faac5.png";